const modals = {
  state: () => ({
    report: {
      type: '',
      module: '',
      lection: '',
    },
  }),
  mutations: {
    updateReportModal(state, payload) {
      if (payload.type === 'lection' || payload.type === 'exam') {
        state.report.type = payload.type;
        state.report.module = payload.module;
        state.report.lection = payload.lection;
      } else if (payload.type === 'homework' && payload.type === 'resources') {
        state.report.type = payload.type;
        state.report.module = '';
        state.report.lection = '';
      } else {
        state.report.type = payload.type;
        state.report.module = '';
        state.report.lection = '';
      }
    },
  },
  actions: {
    openReportModal(context, params) {
      context.commit('updateReportModal', params);
    },
  },
};

export default modals;
